/**
 * @fileoverview `mapDateKeyword` — translates the discover URL-state date
 * vocabulary into the `/events/discover` `date` query.
 *
 * API-1820 — the preset → keyword table is `DATE_WINDOW_PRESETS` in
 * `@loci/validation` (`dateWindows.ts`), the one definition web and the API
 * share. `tonight` → `today`, `weekend` → `this-weekend`; `tomorrow`, `next7`,
 * `next30` and `this-week` keep their names. Calendar-picker ISO ranges pass
 * through unchanged. The windows themselves are resolved on the server clock
 * by the same module; the client never anchors a range on its own clock.
 *
 * `referenceDate` stays in the signature so existing call sites do not change.
 *
 * @since WEB-263
 */
import { dateWindowPreset, isDateWindowPreset } from '@loci/validation';

/**
 * Translate a UI date keyword to the discover `date` query, or return the
 * value unchanged when it doesn't match a known UI keyword (e.g. an ISO range
 * from the calendar picker). Returns `undefined` when input is `undefined`.
 */
export function mapDateKeyword(
  uiKeyword: string | undefined,
  _referenceDate: Date,
): string | undefined {
  if (uiKeyword === undefined) return undefined;
  return isDateWindowPreset(uiKeyword) ? dateWindowPreset(uiKeyword).keyword : uiKeyword;
}
